import { render, staticRenderFns } from "./pageClassList.vue?vue&type=template&id=9737fef8&scoped=true"
import script from "./pageClassList.vue?vue&type=script&lang=js"
export * from "./pageClassList.vue?vue&type=script&lang=js"
import style0 from "./pageClassList.vue?vue&type=style&index=0&id=9737fef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9737fef8",
  null
  
)

export default component.exports